<div class="media-list">
    @for (elem of (content$ | async); track elem.langNeutralItem; let index = $index) {
    <div class="media-item">
        <a [href]="elem.url" target="_blank" rel="noopener" class="cover-image">
            <img alt="{{ elem.description }}"
                src="//www.poettinger.at/img/landtechnik/pdf-preview-200/{{ elem.url | extractFileName }}.jpg"
                fallbackSrc="/assets/images/Piktogramm_Protokoll.svg">
        </a>
        <a [href]="elem.url" target="_blank" rel="noopener" class="title">
            <strong>
                {{ elem.description }}
            </strong>
        </a>
        <div class="download-buttons">
            <ion-button fill="outline" (click)="goToLink(elem.url)" (keydown.enter)="goToLink(elem.url)">
                {{'Download'|translate}}
            </ion-button>
            @if(elem.alternativeLanguages.length > 1) {
            <ion-button fill="outline" id="dropdownButton-{{elem.langNeutralItem}}">
                <ion-icon slot="icon-only" name="chevron-down"></ion-icon>
            </ion-button>
            <ion-popover trigger="dropdownButton-{{elem.langNeutralItem}}">
                <ng-template>
                    <ion-content>
                        <ion-list>
                            @for (subElem of elem.alternativeLanguages; track subElem.iManr) {
                            <ion-item [button]="true" (click)="goToLink(subElem.url)"
                                (keydown.enter)="goToLink(subElem.url)">{{subElem.language}} -
                                {{subElem.description}} ({{subElem.langNeutralItem}})</ion-item>
                            }
                        </ion-list>
                    </ion-content>
                </ng-template>
            </ion-popover>
            }
        </div>
    </div>
    }
</div>